let _ = t => t,
    _t;

import styled from 'styled-components';
import { OLAF } from 'HubStyleTokens/colors';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
export const StickyTabsContainer = styled.div.withConfig({
  displayName: "StickyContainer__StickyTabsContainer",
  componentId: "e5jl86-0"
})(["position:sticky;top:-1px;z-index:100;background:", ";width:100%;height:63px;display:flex;justify-content:end;box-shadow:", ";", ""], OLAF, ({
  isIntersecting = false
}) => !isIntersecting ? '0 2px 4px rgba(0, 0, 0, 0.1)' : 'unset', breakpoint.phone(_t || (_t = _`
    display: none;
  `)));
export default StickyTabsContainer;